
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 移除样式（可选）
export const hideMobileChatBtn = () => {
  chatBtnToggle(false).then(r => {})
}
export const showMobileChatBtn = () => {
  chatBtnToggle(true).then(r => {})
}



export const chatBtnToggle = async (show = true) => {

  let count = 0
  while (count < 20) {
    if (window.document.querySelector('section')) {
      window.document.querySelector('section').style.display = show ? 'block' : 'none'
      break
    }
    await delay(100)
    count++
  }

};